module.exports = __webpack_public_path__ + "img/Bitmap5.3cf44c17.png";